import React from 'react';
import PropTypes from 'prop-types';

import {
  Dropdown,
} from 'semantic-ui-react';

import _ from 'lodash';
import { compose } from 'recompose';

import hasUserInfo from '../../hocs/has-user-info';
import hasRESTClient from '../../hocs/has-rest-client';

class BusinessUnitsSelector extends React.Component {
  //
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      isLoading: false,
    };
  }

  async componentDidMount() {
    const { restClient, userInfo: { organisationId }, onSelected } = this.props;
    const response = await restClient.get(`businessUnits?filter[organisation]=${organisationId}`);
    const businessUnits = _.get(response, 'data.data', []);
    const options = _.map(businessUnits, businessUnit => ({
      key: _.get(businessUnit, 'id'),
      value: _.get(businessUnit, 'id'),
      text: _.get(businessUnit, 'attributes.value'),
      onClick: () => onSelected(_.get(businessUnit, 'id'), businessUnits),
    }));
    this.setState({
      isLoading: false,
      options,
    });
  }

  render() {
    const { selectedBusinessUnits, onUnselected } = this.props;
    const { options, isLoading } = this.state;
    return (
      <Dropdown
        placeholder="Select business units and brands"
        fluid
        loading={isLoading}
        search
        selection
        multiple
        options={options}
        value={selectedBusinessUnits}
        onLabelClick={(event, { value }) => onUnselected(value)}
      />
    );
  }
}

BusinessUnitsSelector.propTypes = {
  onSelected: PropTypes.func.isRequired,
  onUnselected: PropTypes.func.isRequired,
  selectedBusinessUnits: PropTypes.func.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(BusinessUnitsSelector);



/** WEBPACK FOOTER **
 ** ./src/components/business-units-selector/index.js
 **/